/**
 * Smoothness Operationalization Arc rig (2026-05-13).
 *
 * Opens the 3-pillar smoothness verdict + Frame Jitter + Reconcile
 * Toggle + Event Rate windows so DJ can play-test smoothness without
 * manual setup. Trackers fire on a 10s delay so cold-start frames
 * don't pollute the server-side jitter aggregate.
 */

import type { PlaytestRig } from '../environment/devConfig';

export const SMOOTHNESS_ARC_RIG: PlaytestRig = {
  enabled: true,
  label: 'smoothness-operationalization-arc-2026-05-13',
  toolsToOpen: ['smoothnessDashboard', 'frameJitter', 'eventRate'],
  enableFrameJitterTracking: true,
  enableReactRenderTracking: true,
  enableSnapshotStats: true,
  trackerEnableDelayMs: 10000,
};
